import { render, staticRenderFns } from "./dismiss.vue?vue&type=template&id=13d26d3a&"
import script from "./dismiss.vue?vue&type=script&lang=js&"
export * from "./dismiss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports